import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Link } from 'gatsby'
import * as sanitizeHtml from 'sanitize-html';


import Mailchimp from './mailchimp'

import { ICONS } from '../utils/constants';
import Icon from '../components/icon'
import {
  Footer,
  MobileIcon,
  Column,
  Title,
  List
} from '../styled/footer'


const FooterComponent = ({ theme, margin, noMinHeight }) => {
  const data = useStaticQuery(graphql`
    query footer {
      wp {
        siteSettings {
          footer {
            columnFour {
              content {
                ... on WpFooterColumnFourContentTextLayout {
                  content
                  fieldGroupName
                }
                ... on WpFooterColumnFourContentExternalLinkLayout {
                  externalLink
                  fieldGroupName
                  label
                }
                ... on WpFooterColumnFourContentInternalLinkLayout {
                  fieldGroupName
                  internalLink {
                    target
                    title
                    url
                  }
                }
                ... on WpFooterColumnFourContentEmailLayout {
                  email
                  fieldGroupName
                  label
                }
                ... on WpFooterColumnFourContentPhoneLayout {
                  fieldGroupName
                  label
                  phone
                }
                ... on WpFooterColumnFourContentNewsletterSignupLayout {
                  fieldGroupName
                  label
                }
              }
              title
              fieldGroupName
            }
            fieldGroupName
            columnOne {
              content {
                ... on WpFooterColumnOneContentTextLayout {
                  content
                  fieldGroupName
                }
                ... on WpFooterColumnOneContentInternalLinkLayout {
                  fieldGroupName
                  internalLink {
                    target
                    title
                    url
                  }
                }
                ... on WpFooterColumnOneContentExternalLinkLayout {
                  externalLink
                  fieldGroupName
                  label
                }
                ... on WpFooterColumnOneContentEmailLayout {
                  email
                  fieldGroupName
                  label
                }
                ... on WpFooterColumnOneContentPhoneLayout {
                  fieldGroupName
                  label
                  phone
                }
                ... on WpFooterColumnOneContentNewsletterSignupLayout {
                  fieldGroupName
                  label
                }
              }
              fieldGroupName
              title
            }
            columnThree {
              content {
                ... on WpFooterColumnThreeContentTextLayout {
                  content
                  fieldGroupName
                }
                ... on WpFooterColumnThreeContentInternalLinkLayout {
                  fieldGroupName
                  internalLink {
                    target
                    title
                    url
                  }
                }
                ... on WpFooterColumnThreeContentExternalLinkLayout {
                  externalLink
                  fieldGroupName
                  label
                }
                ... on WpFooterColumnThreeContentEmailLayout {
                  email
                  fieldGroupName
                  label
                }
                ... on WpFooterColumnThreeContentPhoneLayout {
                  fieldGroupName
                  label
                  phone
                }
                ... on WpFooterColumnThreeContentNewsletterSignupLayout {
                  fieldGroupName
                  label
                }
              }
              fieldGroupName
              title
            }
            columnTwo {
              content {
                ... on WpFooterColumnTwoContentTextLayout {
                  content
                  fieldGroupName
                }
                ... on WpFooterColumnTwoContentInternalLinkLayout {
                  fieldGroupName
                  internalLink {
                    target
                    title
                    url
                  }
                }
                ... on WpFooterColumnTwoContentExternalLinkLayout {
                  externalLink
                  fieldGroupName
                  label
                }
                ... on WpFooterColumnTwoContentEmailLayout {
                  email
                  fieldGroupName
                  label
                }
                ... on WpFooterColumnTwoContentPhoneLayout {
                  fieldGroupName
                  label
                  phone
                }
                ... on WpFooterColumnTwoContentNewsletterSignupLayout {
                  fieldGroupName
                  label
                }
              }
              fieldGroupName
              title
            }
          }
        }
      }
    }
  
  `)

  const { footer } = data.wp.siteSettings

  return (
    <Footer theme={ theme } margin={ margin } noMinHeight={ noMinHeight }>
      <MobileIcon>
        <Icon 
          icon={ICONS.DOWN} 
          color={ `var(--color-black)` } 
        />
      </MobileIcon>

      <Column>
        <Title>{ footer.columnOne.title }</Title>
        <FooterBuilder content={ footer.columnOne.content } />
      </Column>     

      <Column>
        <Title>{ footer.columnTwo.title }</Title>
        <FooterBuilder content={ footer.columnTwo.content } />
      </Column>    

      <Column>
        <Title>{ footer.columnThree.title }</Title>
        <FooterBuilder content={ footer.columnThree.content } />
      </Column>    

      <Column>
        <Title>{ footer.columnFour.title }</Title>
        <FooterBuilder content={ footer.columnFour.content } />
      </Column>    

    </Footer>
  )
}

export default FooterComponent


const FooterBuilder = ({ content }) => {
  return (
    <List>
      { content.map(( block, i ) => {
        if (block && block.fieldGroupName) {
          const type = block.fieldGroupName
          const blockProps = {
            block,
          }

          const Default = () => (
            <div>
              <pre style={{ whiteSpace: 'normal', fontSize: '14px' }}>In Page Builder, the mapping of this component is missing: <strong>{type}</strong></pre>
            </div>
          )
          
          const blockList = {
            FooterColumnOneContentExternalLinkLayout: ExternalLink,
            FooterColumnTwoContentExternalLinkLayout: ExternalLink,
            FooterColumnThreeContentExternalLinkLayout: ExternalLink,
            FooterColumnFourContentExternalLinkLayout: ExternalLink,

            FooterColumnOneContentInternalLinkLayout: InternalLink,
            FooterColumnTwoContentInternalLinkLayout: InternalLink,
            FooterColumnThreeContentInternalLinkLayout: InternalLink,
            FooterColumnFourContentInternalLinkLayout: InternalLink,

            FooterColumnOneContentEmailLayout: Email,
            FooterColumnTwoContentEmailLayout: Email,
            FooterColumnThreeContentEmailLayout: Email,
            FooterColumnFourContentEmailLayout: Email,

            FooterColumnOneContentPhoneLayout: Phone,
            FooterColumnTwoContentPhoneLayout: Phone,
            FooterColumnThreeContentPhoneLayout: Phone,
            FooterColumnFourContentPhoneLayout: Phone,

            FooterColumnOneContentTextLayout: Text,
            FooterColumnTwoContentTextLayout: Text,
            FooterColumnThreeContentTextLayout: Text,
            FooterColumnFourContentTextLayout: Text,

            FooterColumnOneContentNewsletterSignupLayout: Mailchimp,
            FooterColumnTwoContentNewsletterSignupLayout: Mailchimp,
            FooterColumnThreeContentNewsletterSignupLayout: Mailchimp,
            FooterColumnFourContentNewsletterSignupLayout: Mailchimp,

            Default: Default,
          }

          const BlockTag = blockList[type] ? blockList[type] : blockList['Default']
          
          return (
            <li key={ i }>
              <BlockTag { ...blockProps } />
            </li>
          )
        }

        return null
      })}
    </List>
  )
} 

const ExternalLink = ({ block }) => (
  <a href={ block.externalLink }>{ block.label }</a>
)

const cmsHost = process.env.GATSBY_CMS_URL.replace(/^https?:\/\//, '')
const cmsUrlPattern = new RegExp(`^https?://${cmsHost}`)

const InternalLink = ({ block }) => {
  const url = cmsUrlPattern.test(block.internalLink.url) ? block.internalLink.url.replace(cmsUrlPattern, '') : block.internalLink.url
  // const title = sanitizeHtml(block.internalLink.title )

  return (
    <Link to={ url } dangerouslySetInnerHTML={{__html: sanitizeHtml(block.internalLink.title ) }} />
  )
}

const Email = ({ block }) => (
  <a href={`mailto: ${ block.email }`}>{ block.label }</a>
)

const Phone = ({ block }) => (
  <a href={`tel: ${ block.phone }`}>{ block.label }</a>
)

const Text = ({ block }) => (
  <p>{ block.content }</p>
)